export function cleanupHTMLTemplate(template) {
    if (!template) {
        console.warn('[CLEANUPHTMLTEMPLATE] No template provided.');
        return '';
    }
    const sermonclip = template.querySelector('[data-amelement="sermonclip"]');
    if (sermonclip) {
        console.log('[Cleanup found sermonclip element]');
        const sermonclipvideo = sermonclip.querySelector('video');
        if (sermonclipvideo) {
            console.log('[Cleanup] Found sermonclip video element, removing source tags');
            sermonclipvideo.querySelectorAll('source').forEach(source => {
                console.log('source tag found:', source, source.type);
                if (source.type == 'video/mp4' || !source.type) {
                    console.warn('[Cleanup] found mp4 source tag converting to webm');
                    source.type = 'video/webm';
                }
            });
            sermonclipvideo.muted = true;
            sermonclipvideo.preload = 'auto';
        }
    }
    template.querySelectorAll('.stampElem').forEach(item => {
        const elem = item;
        // Check to see if width and height of image elem
        const imgElem = elem.querySelector('img');
        if (imgElem) {
            console.log('Image element');
            if (imgElem.style.objectFit === 'cover') {
                imgElem.style.objectFit = 'contain';
                imgElem.style.width = '100%';
                imgElem.style.height = '100%';
                console.log('Applied image element fix');
            }
        }
        // Check to see if width and height are fixed in pixels
        const computed = window.getComputedStyle(elem);
        // @ts-ignore
        const style = elem.style;
        if (style.width.includes('%') || style.width == '') {
            console.log('Computed size:', style.width, style.height);
            console.log('Element:', elem);
            console.log('Width is in percentage for element', elem);
            // Convert to pixels
            const parent = elem.parentElement;
            console.log('Parent:', parent);
            // if(parent && style.width !== '') {
            //     const parentWidth = parent.offsetWidth;
            //     const width = parseInt(computed.width);
            //     const newWidth = (width / 100) * parentWidth;
            //     elem.style.width = `${newWidth}px`;
            //     console.log('updated width to:', newWidth);
            // } else {
            //     console.log('Going with computed width');
            elem.style.width = `${computed.width}px`;
            // }
        }
        if (style.height.includes('%') || style.height == '') {
            // const parent = elem.parentElement;
            // if(parent && style.height !== '') {
            //     const parentHeight = parent.offsetHeight;
            //     const height = parseInt(style.height);
            //     const newHeight = (height / 100) * parentHeight;
            //     elem.style.height = `${newHeight}px`;
            //     console.log('updated height to:', newHeight);
            // } else {
            //     console.log('Going with computed height', computed.height);
            if (elem)
                elem.style.height = `${computed.height}px`;
            // }
        }
    });
    return template.innerHTML;
}
